/**
 * @generated SignedSource<<78614f32ed80365d04e71fd08bf225d8>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedFeaturedModule_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedFeaturedModuleContent_viewer">;
  readonly " $fragmentType": "HpSharedFeaturedModule_viewer";
};
export type HpSharedFeaturedModule_viewer$key = {
  readonly " $data"?: HpSharedFeaturedModule_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedFeaturedModule_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedFeaturedModule_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HpSharedFeaturedModuleContent_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "0da9ea44987b5b0f84002e538d0d1901";

export default node;
